import { MoreHorizRounded } from "@mui/icons-material";
import { Breadcrumbs, IconButton, Menu, MenuItem } from "@mui/material";
import { useState } from "react";
import { ParentTaskItemLabel } from "src/components/taskItems";
import { Links } from "src/constants";
import { TaskItemParentDto } from "src/http";

interface IProps {
  taskItemParent: TaskItemParentDto;
  linksOpenDrawer?: boolean;
}

const TaskItemPathBreadcrumbs = (props: IProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const breadcrumbs = getTaskItemPathBreadcrumbs(props.taskItemParent);

  if (breadcrumbs.length <= 2) {
    return (
      <Breadcrumbs>
        {breadcrumbs.map((x, i) => (
          <ParentTaskItemLabel
            parentTaskItem={x}
            hideTeamName
            key={i}
            openDrawerOnClick={props.linksOpenDrawer}
            sx={{ maxWidth: "190px" }}
          />
        ))}
      </Breadcrumbs>
    );
  } else {
    const firstBreadcrumb = breadcrumbs[0];
    const lastBreadcrumb = breadcrumbs[breadcrumbs.length - 1];

    return (
      <>
        <Breadcrumbs>
          <ParentTaskItemLabel
            parentTaskItem={firstBreadcrumb}
            hideTeamName
            openDrawerOnClick={props.linksOpenDrawer}
            sx={{ maxWidth: "190px" }}
          />
          <IconButton size="small" onClick={(event) => setAnchorEl(event.currentTarget)}>
            <MoreHorizRounded />
          </IconButton>
          <ParentTaskItemLabel
            parentTaskItem={lastBreadcrumb}
            hideTeamName
            openDrawerOnClick={props.linksOpenDrawer}
            sx={{ maxWidth: "190px" }}
          />
        </Breadcrumbs>

        <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
          {breadcrumbs.slice(1, -1).map((x, i) => (
            <MenuItem
              href={Links.TaskItemDetail(x.taskItemGuid)}
              key={i}
              onClick={(e) => {
                setAnchorEl(null);
                e.preventDefault();
              }}
            >
              <ParentTaskItemLabel
                parentTaskItem={x}
                hideTeamName
                openDrawerOnClick={props.linksOpenDrawer}
                sx={{ maxWidth: "600px" }}
              />
            </MenuItem>
          ))}
        </Menu>
      </>
    );
  }
};

function getTaskItemPathBreadcrumbs(parent: TaskItemParentDto) {
  const breadcrumbs: TaskItemParentDto[] = [];
  let current: TaskItemParentDto | undefined = parent;

  while (current) {
    breadcrumbs.push(current);
    current = current.parentTaskItem;
  }

  return breadcrumbs.reverse();
}

export { TaskItemPathBreadcrumbs };
